<template>
  <div class="home">
    <div class="ms-2 me-2 mt-3 mb-4">
      <main>

        <div id="carouselExampleCaptions" class="carousel slide mb-5" data-bs-ride="false">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <a href="https://fvvfmi.uz/" target="_blank">
                <img src="https://fvvfmi.uz/static/img/index_header_bg.796f64de.jpg" class="d-block mx-auto" style="width: 1200px;" alt="https://fvvfmi.uz/media/gallery/665b454f-7534-404b-a380-4529f04eb1b2/IMG_1735.webp">
                <div class="carousel-caption d-none d-md-block">
                  <h5>Fuqaro muhofazasi instituti</h5>
                </div>
              </a>
            </div>
            <div class="carousel-item">
              <a href="https://fvvfmi.uz/" target="_blank">
                <img src="@/assets/fvv.png" class="mx-auto d-block" style="width: 1200px;" alt="https://fvvfmi.uz/media/gallery/665b454f-7534-404b-a380-4529f04eb1b2/IMG_1735.webp">
                <div class="carousel-caption d-none d-md-block">
                  <h5>Favqulotda vaziyatlar vazirligi</h5>
                </div>
              </a>
            </div>
            <div class="carousel-item">
              <a href="https://fvvfmi.uz/" target="_blank">
                <img src="@/assets/fvv.png" class="d-block mx-auto" style="width: 1200px;"    alt="https://fvvfmi.uz/media/gallery/665b454f-7534-404b-a380-4529f04eb1b2/IMG_1735.webp">
                <div class="carousel-caption d-none d-md-block">
                </div>
              </a>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
          <div style="margin-left:43%;padding-top: 3%;">

            <a href="https://fvvfmi.uz/" class="text-decoration-none">Fuqaro muhofazasi instituti</a>
          </div>
        </div>
        
        <div class="ms-5 me-5 mt-3 mb-4 con">
          <hr>
          
          <!-- START THE FEATURETTES -->
         
          <div class="mt-5 row justify-content-center">
            <div class="col-lg-6 mt-5 mb-5">
              <h2 class="featurette-heading">Mustaqil o‘rganuvchilar uchun</h2>
              <p class="lead">Some great placeholder content for the first featurette here. Imagine some exciting prose here.</p>
            </div>
            <div class="col-lg-4 mt-5 mb-5">
              <!-- <svg class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" width="500" height="500" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 500x500" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#eee"></rect><text x="50%" y="50%" fill="#aaa" dy=".3em">500x500</text></svg> -->
              <img src="@/assets/mustaqil.jpg" class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" alt="">
            </div>
          </div>

          <hr class="">

          <div class="row justify-content-center">
            <div class="col-lg-6 order-md-2 mt-5 mb-5">
              <h2 class="featurette-heading">Mas’ul hodimlar uchun </h2>
              <p class="lead">Another featurette? Of course. More placeholder content here to give you an idea of how this layout would work with some actual real-world content in place.</p>
            </div>
            <div class="col-lg-4 order-md-1 mt-5 mb-5">
              <!-- <svg class="col-xs-3 bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" width="500" height="500" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 500x500" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#eee"></rect><text x="50%" y="50%" fill="#aaa" dy=".3em">500x500</text></svg> -->
              <img src="https://fvvfmi.uz/media/images/photo_2022-11-24_18-03-55.jpg" class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" alt="">

            </div>
          </div>

          <hr class="">

          <div class="row justify-content-center">
            <div class="col-lg-6 mt-5 mb-5" >
              <h2 class="featurette-heading">Sohada o‘z bilimini oshirmoqchi bo‘lganlar uchun</h2>
              <p class="lead">And yes, this is the last block of representative placeholder content. Again, not really intended to be actually read, simply here to give you a better view of what this would look like with some actual content. Your content.</p>
            </div>
            <div class="col-lg-4 mt-5 mb-5">
              <!-- <svg class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" width="500" height="500" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 500x500" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#eee"></rect><text x="50%" y="50%" fill="#aaa" dy=".3em">500x500</text></svg> -->
              <img src="@/assets/sohada.jpg" class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" alt="">

            </div>
          </div>

          <hr class="featurette-divider">

          <!-- /END THE FEATURETTES -->

        </div><!-- /.container -->

      </main>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import SideBar from "@/components/SideBar";
export default {
  name: "HomeView",
  components: {
    SideBar,
  },
  data() {
    return {
      posts: [],
      total_page: 0,
      current_page: 1,
    };
  },

  methods: {
    truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    next_page(item){
      this.current_page=item
      axios.get(`courses/get_all_blogs/?page=${item}`).then((response) => {
      this.total_page = response.data.total_page;
      this.current_page = response.data.current_page;
      this.posts = response.data.results;
    });
    }
  },
};
</script>
<style>
.carousel-control-prev-icon, .carousel-control-next-icon {
    outline: black;
    background-color: rgba(0, 0, 0, 0.3);
    background-size: 100%, 100%;
    border-radius: 50%;
    /* border: 1px solid black; */
}
</style>